import type { BetaRedirect } from '@/types/beta-dashboard'

const httpUrlToPath = (value: string) => {
    const input = String(value || '').trim()

    if (!/^https?:\/\//i.test(input)) return input

    try {
        return new URL(input).pathname || '/'
    } catch {
        return input.replace(/^https?:\/\/[^/]+/i, '') || '/'
    }
}

export const normalizeBetaRedirectPath = (value: string) => {
    let path = httpUrlToPath(value)
    if (!path) return '/'

    path = path.trim().toLowerCase()

    const accented = 'àáäâèéëêìíïîòóöôùúüûñç·,:;'
    const normalized = 'aaaaeeeeiiiioooouuuunc----'

    for (let index = 0; index < accented.length; index += 1) {
        path = path.replace(
            new RegExp(accented.charAt(index), 'g'),
            normalized.charAt(index),
        )
    }

    return path
        .replace(/\(/g, '')
        .replace(/\)/g, '')
        .replace(/[^a-z0-9 -|.]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-') || '/'
}

export const normalizeBetaRedirects = (redirects: BetaRedirect[]): BetaRedirect[] => (
    redirects.map((redirect) => ({
        ...redirect,
        from: {
            ...redirect.from,
            path: normalizeBetaRedirectPath(redirect.from.path),
        },
        to: {
            ...redirect.to,
            path: normalizeBetaRedirectPath(redirect.to.path),
        },
    }))
)
